import api from "./api"
import API_ENDPOINTS from "../config/api"

const REFRESH_INTERVAL = 9 * 60 * 1000 // 9 minutes

export const startTokenRefresher = () => {
  setInterval(async () => {
    try {
      const refreshToken = localStorage.getItem("refresh_token")
      if (!refreshToken) return

      const response = await api.post(API_ENDPOINTS.AUTH.REFRESH_TOKEN, {
        refresh_token: refreshToken,
      })

      const { access_token, refresh_token } = response.data
      localStorage.setItem("access_token", access_token)
      localStorage.setItem("refresh_token", refresh_token)
    } catch (error) {
      console.error("Failed to refresh token:", error)
    }
  }, REFRESH_INTERVAL)
}
